// extracted by mini-css-extract-plugin
export default {"sideBarHide":"player_sideBarHide__JO9bg"};